import React, { Component } from 'react';
import './styles.css';
import { NavLink } from 'react-router-dom';
import { BUSINESSPLAN } from '../../../routes';
import { formatRoute } from 'react-router-named-routes';
class GreyButton extends Component {
	render() {
		const { game } = this.props;
		return (
			<NavLink
				to={formatRoute(BUSINESSPLAN, {
					gameID: game.id,
					businessPlanID: game.lastSubmission
				})}
				className="results-document-layout-grey-button"
			>
				Back to last Business Plan
			</NavLink>
		);
	}
}

export default GreyButton;
